var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcImages = require("../../../../shared/extensions/footprintGenerator/ipcImages/index.js");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var IpcPthPadGeneratorInteractionModel = require('./ipcPthPadGeneratorInteractionModel.js');

var HeaderGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    IpcPthPadGeneratorInteractionModel.apply(this, arguments);

    this.verticalPadCount = this.shadow("verticalPadCount",
        function() {
            return this.data.verticalPadCount();
        },
        function(value) {
            value = parseInt(value);
            
            //pad count should not be zero
            if(value === 0) return false;

            var status = this.data.verticalPadCount(value);
            this.updateNameList();
            return status;
        },
        [this.data.verticalPadCount]
    );

    this.horizontalPinPitch = this.shadow("horizontalPinPitch",
        function() {
            return this.data.horizontalPinPitch() / this.getUnitFactor();
        },
        function(value) {
            return this.data.horizontalPinPitch(parseFloat(value) * this.getUnitFactor());
        }, 
        [
            this.data.horizontalPinPitch, this.userSettingsModel.distanceUnit
        ]
    );

    this.showRowPitch = this.shadow("showRowPitch",
        function() {
            return this.data.verticalPadCount() > 1;
        },
        null,
        [
            this.data.verticalPadCount
        ]
    );

    this.showColPitch = this.shadow("showColPitch",
        function() {
            return this.data.horizontalPadCount() > 1;
        },
        null,
        [
            this.data.horizontalPadCount
        ]
    );

    this.showPinNumberingSequence = this.shadow("showPinNumberingSequence",
        function() {
            return this.data.horizontalPadCount() > 1 || this.data.verticalPadCount() > 1;
        },
        null,
        [
            this.data.horizontalPadCount, this.data.verticalPadCount
        ]
    );

    this.pinNumberSequencePattern = this.shadow("pinNumberSequencePattern",
        function() {
            return this.data.pinNumberSequencePattern();
        },
        function(value) {
            return this.data.pinNumberSequencePattern(value);
        }, 
        [
            this.data.pinNumberSequencePattern
        ]
    );

    this.footprintOriginLocation = this.shadow("footprintOriginLocation",
        function() {
            return this.data.footprintOriginLocation();
        },
        function(value) {
            return this.data.footprintOriginLocation(value);
        }, 
        [
            this.data.footprintOriginLocation
        ]
    );

    this.terminalPostLength = this.shadow("terminalPostLength",
        function() {
            return this.data.terminalPostLength() / this.getUnitFactor();
        },
        function(value) {
            return this.data.terminalPostLength(parseFloat(value) * this.getUnitFactor());
        }, 
        [
            this.data.terminalPostLength, this.userSettingsModel.distanceUnit
        ]
    );
};

lib_core.inherit(HeaderGeneratorInteractionModel, IpcPthPadGeneratorInteractionModel);
HeaderGeneratorInteractionModel.$class = 'HeaderGeneratorInteractionModel';
module.exports = HeaderGeneratorInteractionModel;

HeaderGeneratorInteractionModel.prototype.getInspectorElementForPinNumberingPatterns = function() {
    var pinNumberSequencePattern = cio_datamodel.IpcDataModel.PthComponentAttribute.type.HEADER.pinNumberSequencePattern;
    var pinNumberSequencePatternImagesList = [];

    for (var p in pinNumberSequencePattern) {
        var patternKey = pinNumberSequencePattern[p].key;
        console.assert(IpcImages.headerStraight.pinSequence[patternKey], "No image found for the pin sequence pattern " + patternKey);

        pinNumberSequencePatternImagesList.push({
            image: global.FULLDEPLOYMENTPATH + IpcImages.headerStraight.pinSequence[patternKey],
            tooltip: this.LCLZ(p, pinNumberSequencePattern[p].description),
            data: patternKey,
            selected: (this.data.pinNumberSequencePattern() === patternKey)
        });
    }

    var pinNumberSequencePatternRow = {
        label: this.LCLZ('pinNumbering', 'Pin Numbering'),
        tooltip: this.LCLZ('pinNumbering', 'Pin Numbering'),
        type: ui_extensions.InspectorInputType.SELECTABLE_IMAGE_GROUP,
        images: pinNumberSequencePatternImagesList,
        datamember: this.pinNumberSequencePattern,
        visible: this.showPinNumberingSequence
    };

    return pinNumberSequencePatternRow;
};

HeaderGeneratorInteractionModel.prototype.getFootprintOriginLocation = function() {
    var footprintOriginLocation = [];

    for (var t in cio_datamodel.IpcDataModel.PthComponentAttribute.type.HEADER.footprintOriginLocation) {
        var l = cio_datamodel.IpcDataModel.PthComponentAttribute.type.HEADER.footprintOriginLocation[t];
        footprintOriginLocation.push([this.LCLZ(t, l), l]);
    }
    
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('footprintOrigin', 'Footprint Origin'), this.footprintOriginLocation, footprintOriginLocation)];
};

HeaderGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    var rows = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#Rows', '# Rows'), this.verticalPadCount);
    var cols = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#Cols', '# Cols'), this.horizontalPadCount);

    return [rows, cols];
};

HeaderGeneratorInteractionModel.prototype.getInspectorElementForPitch = function() {
    var rowPitch = PackageGeneratorInspectorConfig.getValueFixedUnit('e', this.LCLZ('rowPitch', 'Row Pitch'), this.verticalPinPitch, this.userSettingsModel.distanceUnit, this.showRowPitch);
    var colPitch = PackageGeneratorInspectorConfig.getValueFixedUnit('d', this.LCLZ('colPitch','Col Pitch'), this.horizontalPinPitch, this.userSettingsModel.distanceUnit, this.showColPitch);

    return [rowPitch, colPitch];
};

HeaderGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('terminalWidth', 'Terminal Width'), true, null, false, this.terminalWidth, this.userSettingsModel.distanceUnit)];
};

HeaderGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    var tailLength = PackageGeneratorInspectorConfig.getMinMaxRow('L1', this.LCLZ('terminalTailLength', 'Terminal Tail Length'), true, null, false, this.terminalTailLength, this.userSettingsModel.distanceUnit);
    var postLength = PackageGeneratorInspectorConfig.getMinMaxRow('L2', this.LCLZ('terminalPostLength', 'Terminal Post Length'), true, null, false, this.terminalPostLength, this.userSettingsModel.distanceUnit);

    return [tailLength, postLength];
};

HeaderGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getFootprintOriginLocation());
    imElements = imElements.concat(this.getInspectorElementForPinNumberingPatterns());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForPadHoleRatio());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};
